import { useEffect } from 'react'
import { identifySubscriberAsync } from '@mc/track-event'

const HotJar = () => {
  useEffect(() => {
    identifySubscriberAsync()
  }, [])

  return <></>
}

export default HotJar
